import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { RelatedService } from 'src/pages/billing/billing.types';
import { useCreateRelatedServiceMutation } from 'src/pages/billing/billingApi';
import { useAppDispatch } from 'src/store';
import { addToast } from 'src/toasts/ToastsSlice';

import { ServiceNotServicedFormData, serviceNotServicedFormSchema } from '../RelatedService.schema';

type ServiceNotServicedFormHookProps = {
  setEditMode: (editMode: boolean) => void;
  relatedService: RelatedService;
};

const defaultValues: ServiceNotServicedFormData = {
  serviceType: 'SP',
  reason: '',
};

export const useServiceNotServicedForm = ({
  setEditMode,
  relatedService,
}: ServiceNotServicedFormHookProps) => {
  const dispatch = useAppDispatch();
  const { id } = useParams();
  const [createRelatedService, { isLoading }] = useCreateRelatedServiceMutation();

  const initialValues: ServiceNotServicedFormData = {
    serviceType: relatedService.serviceType || defaultValues.serviceType,
    reason: relatedService.reason || defaultValues.reason,
  };

  const methods = useForm<ServiceNotServicedFormData>({
    resolver: zodResolver(serviceNotServicedFormSchema),
    defaultValues: initialValues,
    mode: 'onChange',
  });

  const handleSubmit = methods.handleSubmit(async (data) => {
    try {
      await createRelatedService({
        id: id!,
        payload: {
          serviceType: data.serviceType,
          status: 'NotServiced',
          reason: data.reason,
        },
      }).unwrap();

      dispatch(addToast({ text: 'Form saved successfully', type: 'positive' }));
      setEditMode(false);
    } catch (error) {
      dispatch(addToast({ text: 'Error saving form', type: 'negative' }));
      console.error('Error saving form:', error);
    }
  });

  return {
    methods,
    handleSubmit,
    isLoading,
  };
};
